import api from "../..";
import type { Story, StoryDetail, GetStoryByIdParams } from "./types";

export const getStories = async (): Promise<Story[]> => {

  return await api.get("/admin/story/")
  .then(res => res.data.data)
  .catch(() => {return []});
};

export const getStoryById = async ({ uuid }: GetStoryByIdParams): Promise<StoryDetail | null> => {

  return await api.get(`/admin/story/${uuid}/`)
  .then(res => res.data.data)
  .catch(() => {return null});
};